var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-content"},[_c('Header'),_c('router-view'),_c('Footer')],1),_c('div',{staticClass:"app-background"})])}
var staticRenderFns = []

export { render, staticRenderFns }